<template>
    <div class="management-dashboard-section-container">
        <div class="button-container">
            <button class="btn round primary" v-on:click="showAddStateModal()">
                <span>{{$t("addStateText").toUpperCase()}}</span></button>
        </div>
        <div class="section-header row"></div>
        <div class="section-body">
            <table>
                <thead>
                    <tr>
                        <th>{{withCapitalLetter($t("name"))}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(state, index) in partialCollection" :key="index">
                        <td>{{state.name}}</td>
                        <td>
                            <img :src="getEditIcon" 
                                v-on:click="showUpdateStateModal(state)" />
                            <img :src="getDeleteIcon" 
                                v-on:click="showDeleteConfirmation(state)" />
                        </td>
                    </tr>
                    <tr v-if="partialCollection.length === 0">
                        <td class="no-content" colspan="2">{{$t("noContent")}}</td>
                    </tr>
                </tbody>
            </table>
            
            <paginator  :collection="collection" 
                        v-on:onPartialCollectionUpdate="eventHandler"/>
        </div>
        
        <modal v-if="showModal"
            :modalType="modalType"
            :clickOutSideModalHandler="hideModal"
            :showButtons="showModalButtons">
            <component :is="currentModal"
                        :state="selectedState"
                        v-on:close="hideModal"/></modal>

        <modal v-if="showDeleteModal"
            :click-handler="deleteState"
            :clickOutSideModalHandler="hideModal"
            v-on:close="hideModal">
            <div class="removeQuestion">  
                <span class="removeQuestion">
                    {{`${$t("wantToDeleteStateQuestion")}: ${selectedState.name}?`}}</span>
            </div>
        </modal>
    </div>
</template>

<script>

import AddStates from "@/components/BackOffice/ManagementDashboard/States/AddStates.vue";
import UpdateStates from "@/components/BackOffice/ManagementDashboard/States/UpdateStates.vue";
import Modal from "@/common/Modal.vue";
import Paginator from "@/common/Paginator.vue";
import StringUtils from "@/utils/StringUtils.js";

export default {
    name: "States",
    components: {
        "add-states": AddStates,
        "update-states": UpdateStates,
        Modal,
        Paginator,
        StringUtils
    },
    data: function(){
        return {
            currentModal: "",
            showModal: false,
            showDeleteModal: false,
            showModalButtons: false,
            modalType: "vocabularyModal",
            selectedState: null,
            partialCollection: []
        }
    },
    computed: {
        getDeleteIcon(){
            return require("@/assets/icons/ic_delete.svg");
        },
        getEditIcon(){
            return require("@/assets/icons/ic_edit.svg");
        },
        collection(){
            return this.$store.state.managementObj.states;
        }
    },
    methods: {
        hideModal(){
            this.showModal = false;
            this.showDeleteModal = false;
        },
        showAddStateModal(){
            this.currentModal = "add-states";
            this.showModal = true;
        },
        showUpdateStateModal(state){
            this.currentModal = "update-states";
            this.selectedState = state;
            this.showModal = true;
        },
        showDeleteConfirmation(state){
            this.selectedState = state;
            this.showDeleteModal = true;
        },
        deleteState(){
            this.showDeleteModal = false;
            this.$store.dispatch("deleteState", this.selectedState)
                    .then(() => {
                        this.$store.commit('addSnackBarNotification', {
                            message: this.$t("successfulStateDeletingMessage"), 
                            dismissable: false
                        });

                        this.selectedState = null;
                    }, error => {
                        this.$store.commit('addSnackBarNotification', {
                                message: this.$t(error), 
                                dismissable: false
                            });
                    });
        },
        eventHandler(event){
            this.partialCollection = event;
        },
        withCapitalLetter(word){
            return StringUtils.withCapitalLetter(word);
        }
    },
    created: function(){
        this.$store.dispatch("getStates")
            .then(null, error => {
                this.$store.commit('addSnackBarNotification', {
                    message: this.$t(error), 
                    dismissable: true
                });
            });

        this.$store.commit("setManagementDashboardNavBarPath", {
            parent: this.$t("management"),
            child: this.$t("states")
        });
    }
}

</script>

<style lang="less" scoped>

.management-dashboard-section-container{
    width: 968px;
    margin: 10px auto;

    .button-container{
        width: 100%;
        margin-bottom: 5px;

        button{
            height: 40px;
            width: 168px;
            margin-left: 798px;
        }
    }

    .section-header{
        height: 56px;
        color: white;
        background-color: #0A1554;
    }

    .section-body{
        max-width: 968px;
        height: calc(100vh - 225px);
        overflow-y: auto;

        &::-webkit-scrollbar{
            display: none;
        }

        table{
            width: 100%;
            border-collapse: collapse;

            tr{
                height: 56px;
            }

            thead{
                th{
                    text-align: left;
                    width: 90%;

                    :last-child{
                        width: 10%;
                    }
                }
            }

            tbody{
                border-top: 1px solid grey;
                border-bottom: 1px solid grey;

                img{
                    margin-left: 20px;

                    &:hover{
                        cursor: pointer;
                    }
                }

                .no-content{
                    text-align: center;
                }
            }
        }

        .removeQuestion{
            padding: 20px 0px;
        }

        & /deep/ .paginator-container{
            margin-top: 5px;
        }
    }
}

</style>

